import { PageNamesTypes } from '../src/types';
import type { PageName } from '../src/types';
import type { PeopleByCityUserBagPageQuery } from './graphql/user-bag-page-by-city.query.gql-types';

export const sanitizeNames = (
  names: NonNullable<
    NonNullable<
      PeopleByCityUserBagPageQuery['peopleByCityUserBagPage']
    >['names']
  >
): Array<PageName> => {
  return (
    names
      ?.map((name): PageName | null => {
        switch (name?.__typename) {
          case 'PeopleProfileItem': {
            return {
              __typename: PageNamesTypes.profile,
              name: name?.name || '',
              photoUrl: name?.photoUrl || '',
              coach: name?.coach || false,
              url: name?.url || '',
              occupationTitle: name?.occupationTitle || '',
              city: name?.city || '',
            };
          }
          default: {
            return null;
          }
        }
      })
      .reduce<Array<PageName>>((result, name: PageName | null) => {
        if (name) {
          return [...result, name];
        } else {
          return result;
        }
      }, []) || []
  );
};
